module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter sgc-4"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/WordfromAuthor"
    }
  }, [_vm._v("A Word from the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter sgc-4"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter sgc-4"
  }, [_c('span', {
    staticClass: "bold sgc-3"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1"
    }
  }, [_vm._v("1. A Paradox About Hearing God")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-sub sgc-5"
  }, [_vm._v("Why do people say they hear God but so few can explain it?")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter sgc-4"
  }, [_c('span', {
    staticClass: "bold sgc-3"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap2"
    }
  }, [_vm._v("2. Guidelines for Hearing from God")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-sub sgc-5"
  }, [_vm._v("What are some common misunderstandings?")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-scripture sgc-8"
  }, [_vm._v("Hearing God in Scripture: "), _c('em', {
    staticClass: "italic sgc-6"
  }, [_vm._v("1 Kings 19:2-18")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-4 sgc-7"
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter sgc-4"
  }, [_c('span', {
    staticClass: "bold sgc-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Never Alone")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-sub sgc-5"
  }, [_vm._v("How is God with us?")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter sgc-4"
  }, [_c('span', {
    staticClass: "bold sgc-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Our Communicating Cosmos")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-sub sgc-5"
  }, [_vm._v("Does God really talk to people?")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-scripture sgc-8"
  }, [_vm._v("Hearing God in Scripture: "), _c('em', {
    staticClass: "italic sgc-6"
  }, [_vm._v("2 Kings 6:11-17")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter sgc-4"
  }, [_c('span', {
    staticClass: "bold sgc-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Still, Small Voice and Its Rivals")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-sub sgc-5"
  }, [_vm._v("How has God spoken to people before?")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-scripture para-style-override-6 sgc-9"
  }, [_vm._v("Hearing God in Scripture: "), _c('em', {
    staticClass: "italic sgc-6"
  }, [_vm._v("Proverbs 20:27;")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-scripture sgc-8"
  }, [_c('em', {
    staticClass: "italic sgc-6"
  }, [_vm._v("1 Corinthians 2:9-13, 15-16")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter sgc-4"
  }, [_c('span', {
    staticClass: "bold sgc-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Word of God and the Rule of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-sub sgc-5"
  }, [_vm._v("What part does God’s Word have in everyday reality?")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-scripture sgc-8"
  }, [_vm._v("Hearing God in Scripture: "), _c('em', {
    staticClass: "italic sgc-6"
  }, [_vm._v("Psalm 19:1-6; 119:89-91")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter sgc-4"
  }, [_c('span', {
    staticClass: "bold sgc-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Redemption Through the Word of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-sub sgc-5"
  }, [_vm._v("How does hearing God lead to character transformation?")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-scripture sgc-8"
  }, [_vm._v("Hearing God in Scripture: "), _c('em', {
    staticClass: "italic sgc-6"
  }, [_vm._v("Romans 5:10-11; 6:4, 8-11")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter sgc-4"
  }, [_c('span', {
    staticClass: "bold sgc-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Recognizing the Voice of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-sub sgc-5"
  }, [_vm._v("How do we know we are hearing God and not our own voices?")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-scripture sgc-8"
  }, [_vm._v("Hearing God in Scripture: "), _c('em', {
    staticClass: "italic sgc-6"
  }, [_vm._v("1 Chronicles 14:8-17 ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter sgc-4"
  }, [_c('span', {
    staticClass: "bold sgc-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. A Life More Than Guidance")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-sub para-style-override-9 sgc-10"
  }, [_vm._v("How do we learn to listen to God?")]), _vm._v(" "), _c('p', {
    staticClass: "TOC para-style-override-9 sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: "), _c('em', {
    staticClass: "italic sgc-6"
  }, [_vm._v("The Way of the Burning Heart")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC para-style-override-9 sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: "), _c('em', {
    staticClass: "italic sgc-6"
  }, [_vm._v("Key Questions and Answers")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC para-style-override-9 sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC para-style-override-9 sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ScripIndx",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC para-style-override-9 sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0